import { IIntroductionLinkProps } from '../components/home-components/instruction-link';

export const homePageInstructionsMobileData: IIntroductionLinkProps[] = [
  {
    name: 'VIEW NOTES AND HIGHLIGHTS IN THE APP FEED',
    pdfUrl: '/documents/2026_03_29/See Notes and Highlights (MOBILE APP).pdf',
    videoUrl: '',
    breakpoint: 12,
  },
  {
    name: 'FIND AND FOLLOW A LEADER',
    pdfUrl: '/documents/2026_03_29/Find and Follow a Leader (MOBILE APP).pdf',
    videoUrl: '',
    breakpoint: 12,
  },
  {
    name: 'COPY LEADER POSTS TO YOUR LIBRARY',
    pdfUrl: '/documents/2026_03_29/Copy Leader Posts to Library (MOBILE APP).pdf',
    videoUrl: '',
    breakpoint: 12,
  },
  {
    name: 'VIEW LIBRARY, ADD AFFIRMATIONS',
    pdfUrl: '/documents/2026_03_29/View Library and Add Affirmations (MOBILE APP).pdf',
    videoUrl: '',
    breakpoint: 12,
  },
  {
    name: 'SHARE LEADER POSTS',
    pdfUrl: '/documents/2026_03_29/Share Leader Posts (MOBILE APP).pdf',
    videoUrl: '',
    breakpoint: 12,
  },
];
